// extracted by mini-css-extract-plugin
export default {"content":"DialogConfirmation--content--6daf74","icon":"DialogConfirmation--icon--a26acc"};